
import { Form, Lead } from "@/types";

// Helper function to calculate total investment from leads
export function calculateTotalInvestment(leads: Lead[]): number {
  return leads.reduce((total, lead) => {
    // Extract investment amount from lead data
    const investmentRangeStr = Object.values(lead.data).find(value => 
      typeof value === 'string' && 
      (value.includes('$') || value.toLowerCase().includes('under') || value.toLowerCase().includes('over'))
    );
    
    if (!investmentRangeStr) return total;
    
    // Parse the investment amount
    try {
      if (typeof investmentRangeStr !== 'string') return total;
      
      // Handle different formats
      if (investmentRangeStr.toLowerCase().includes('under')) {
        // Take the middle of the range (e.g., "Under $1,000" -> $500)
        const amount = parseInt(investmentRangeStr.replace(/[^0-9]/g, ''));
        return total + (amount / 2);
      } else if (investmentRangeStr.includes('-')) {
        // Take the middle of the range (e.g., "$1,000 - $5,000" -> $3,000)
        const parts = investmentRangeStr.split('-');
        const min = parseInt(parts[0].replace(/[^0-9]/g, ''));
        const max = parseInt(parts[1].replace(/[^0-9]/g, ''));
        return total + ((min + max) / 2);
      } else if (investmentRangeStr.toLowerCase().includes('over')) {
        // Take the amount plus 20% (e.g., "Over $10,000" -> $12,000)
        const amount = parseInt(investmentRangeStr.replace(/[^0-9]/g, ''));
        return total + (amount * 1.2);
      } else {
        // Direct amount (e.g., "$5,000")
        return total + parseInt(investmentRangeStr.replace(/[^0-9]/g, ''));
      }
    } catch (e) {
      console.error("Error parsing investment amount:", e);
      return total;
    }
  }, 0);
}
